module.exports = __webpack_public_path__ + "static/media/Slice13@2x.eb3436af.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_149/img/Slice13@2x.png
// module id = 1441
// module chunks = 0